export default __webpack_public_path__ + "static/media/gbp.33d68f52.svg";